<div class="content">
	<stars-elements-overview></stars-elements-overview>
	<stars-elements-features></stars-elements-features>
	<stars-elements-characters></stars-elements-characters>
	<stars-elements-platforms></stars-elements-platforms>
	<stars-elements-resources></stars-elements-resources>
</div>
